import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field, useForm } from 'react-final-form';
import { Alert, Button, ButtonToolbar, Collapse } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { OnChange } from 'react-final-form-listeners';
import Select from '../../../shared/components/form/Select';
import { subjectLabelValueListByFilter } from '../../../shared/queries/Subject';
import GraphQL from '../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../../redux/actions/loadingActions';
import Modal from '../../../shared/components/Modal';

const CurriculumTab = ({
  t,
  dispatch,
  curriculum,
  steps,
  activeClassesByCourse,
}) => {
  const history = useHistory();
  const [subjects, setSubjects] = useState([]);
  const [subjectsToGenCurriculum, setSubjectsToGenCurriculum] = useState([]);
  const [curriculumGrid, setCurriculumGrid] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const form = useForm();

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const backClickHandler = () => {
    history.push('/minime/curso');
  };

  const loadAllSubject = () => {
    showLoading();
    const filter = {
      id: 0,
      active: true,
      termFilterId: 0,
      filterByStatus: true,
      updaterId: 0,
      subjectLevelFilterId: 0,
    };
    const query = subjectLabelValueListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.subjectListByFilter) {
          setSubjects(res.subjectListByFilter);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const groupBy = (values) => {
    const curriculumUpdated = [];
    if (values.length) {
      const dataMap = new Map();

      values.forEach((value) => {
        if (!dataMap.get(value.step.id)) {
          dataMap.set(value.step.id, []);
        }
        dataMap.get(value.step.id).push({ ...value });
      });
      dataMap.forEach((a) => curriculumUpdated.push(a));

      const subjectsField = curriculumUpdated[0].map(({ subject }) => ({
        ...subject,
        label: subject.name,
        value: subject.id,
      }));
      form.batch(() => {
        form.change('subjects', subjectsField);
      });
      setSubjectsToGenCurriculum(subjectsField);
    }
    setCurriculumGrid(curriculumUpdated);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const generateCurriculum = () => {
    if (showModal) {
      toggleModal();
    }
    let arrAux = [];
    if (curriculumGrid.length) {
      arrAux = curriculumGrid.reduce((arr, value) => arr.concat(value), []);
    }
    if (subjectsToGenCurriculum.length && steps.length) {
      let curriculumGridUpdated = [];
      subjectsToGenCurriculum.forEach((subject) => {
        steps.forEach((step) => {
          const already = arrAux.find((item) => item.subject.id === subject.id);
          if (already) {
            curriculumGridUpdated = [...curriculumGridUpdated, already];
            const indexRemove = arrAux.findIndex((item) => item === already);
            arrAux.splice(indexRemove, 1);
          } else {
            curriculumGridUpdated = [
              ...curriculumGridUpdated,
              {
                id: 0,
                step,
                subject,
                stepWorkLoad: 0,
              },
            ];
          }
        });
      });
      groupBy(curriculumGridUpdated);
    } else if (!subjectsToGenCurriculum.length) {
      showNotificationAutoDestroy(
        'warning',
        t('warnings.title'),
        t('warnings.select-subject-to-generate-curriculum')
      );
    } else if (!steps.length) {
      showNotificationAutoDestroy(
        'warning',
        t('warnings.title'),
        t('warnings.register-course-steps')
      );
    }
  };

  const generate = () => {
    if (curriculumGrid.length) {
      toggleModal();
    } else {
      generateCurriculum();
    }
  };

  const changeStepWorkLoad = (evt, indexStep, cv, indexCv) => {
    const updatedCurriculumGrid = [...curriculumGrid];
    const updatedCv = { ...cv };
    updatedCv.stepWorkLoad = parseFloat(evt.target.value);
    const updatedCvInGrid = updatedCurriculumGrid[indexStep];
    updatedCvInGrid[indexCv] = updatedCv;
    setCurriculumGrid(updatedCurriculumGrid);
  };

  const changeSubjectsToGenCurriculum = (value) => {
    setSubjectsToGenCurriculum(value || []);
  };

  useEffect(() => {
    loadAllSubject();
  }, []);

  useEffect(() => {
    groupBy(curriculum);
  }, [curriculum]);

  useEffect(() => {
    form.change('curriculumGrouped', curriculumGrid);
  }, [curriculumGrid]);
  const colsY = () => {
    return curriculumGrid.map((item, indexStep) => {
      return (
        <div className="col-year">
          <div className="header">{item[0].step.fullName}</div>
          <div className="row-container">
            <div className="w-100">
              {item.map((cv, indexCv) => (
                <div className="row-disc">
                  <input
                    type="number"
                    min={0}
                    value={cv.stepWorkLoad}
                    disabled={activeClassesByCourse > 0}
                    onChange={(evt) =>
                      changeStepWorkLoad(evt, indexStep, cv, indexCv)
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    });
  };
  return (
    <>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.regenerate-grid')}
        toggle={toggleModal}
        modal={showModal}
        onConfirm={generateCurriculum}
      />
      {activeClassesByCourse > 0 ? (
        <Alert color="danger">
          {t('notifications.course-curriculum-with-active-class')}
        </Alert>
      ) : null}
      <div className="form">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.subjects-assigned-course')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="subjects"
              isMulti
              closeMenuOnSelect={false}
              component={Select}
              options={subjects}
              placeholder={t('placeholder.course.select')}
              isDisabled={activeClassesByCourse > 0}
            />
            <OnChange name="subjects">{changeSubjectsToGenCurriculum}</OnChange>
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button
            color="success"
            onClick={generate}
            disabled={activeClassesByCourse > 0}
          >
            {t('general.generate-grade')}
          </Button>
        </ButtonToolbar>
        <div className="form__form-group">
          {curriculumGrid.length ? (
            <Collapse isOpen={!!curriculumGrid.length}>
              <div className="form__form-group">
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('general.distribute-lessons-stage-course')}
                  </span>
                </div>
                <div className="form_form-group-field">
                  <div
                    style={{
                      position: 'relative',
                      overflowX: 'auto',
                      height: (curriculumGrid[0].length + 1) * 56,
                    }}
                  >
                    <div className="course-table-container">
                      <div className="col-disc">
                        <div className="header">{t('general.subjects')}</div>
                        <div className="row-container">
                          <div className="w-100">
                            {curriculumGrid[0].map(({ subject }) => (
                              <div key={subject.id} className="row-disc">
                                {subject.name}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      {colsY()}
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          ) : null}
        </div>
        <Field name="errorGrid">
          {(field) => (
            <Collapse isOpen={!!field.meta.error} className="width100 mt-2">
              <Alert className="text-center" color="danger">
                {field.meta.error}
              </Alert>
            </Collapse>
          )}
        </Field>
      </div>
    </>
  );
};

CurriculumTab.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  curriculum: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  steps: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  activeClassesByCourse: PropTypes.number.isRequired,
};

CurriculumTab.defaultProps = {
  curriculum: [],
  steps: [],
};

export default withTranslation('common')(CurriculumTab);
